export const getPosition = (
  tagLength: number,
  index: number
): number | undefined => {
  if (tagLength <= 10) {
    return
  }

  if (tagLength === 11) {
    return index * 11.2
  }

  if (tagLength === 12) {
    return index * 10.2
  }

  if (tagLength === 13) {
    return index * 9.4
  }

  if (tagLength === 14) {
    return index * 8.6
  }

  if (tagLength === 15) {
    return index * 8
  }

  if (tagLength === 16) {
    return index * 7.5
  }

  if (tagLength === 17) {
    return index * 7
  }

  if (tagLength === 18) {
    return index * 6.6
  }

  if (tagLength === 19) {
    return index * 6.25
  }

  if (tagLength >= 20) {
    return index * 5.9
  }
}
